import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../../utils/api';

export default function AdminExchange() {
  const [orders, setOrders] = useState([]);
  const [markets, setMarkets] = useState([]);

  useEffect(() => {
    Promise.all([api.get('/exchange/admin/orders'), api.get('/exchange/markets')])
      .then(([ordersRes, marketsRes]) => {
        setOrders(ordersRes.data.orders || []);
        setMarkets(marketsRes.data.markets || []);
      })
      .catch((error) => toast.error(error.response?.data?.message || 'Failed to load exchange admin'));
  }, []);

  return (
    <div>
      <div className="section-tag">Admin</div>
      <h1 className="section-title">TOKENIZED <span style={{ color: 'var(--neon-green)' }}>EXCHANGE</span></h1>

      <div className="metric-strip" style={{ margin: '1rem 0 1.5rem' }}>
        <div className="metric-tile"><div className="eyebrow">Markets</div><div className="value" style={{ color: 'var(--neon-green)' }}>{markets.length}</div></div>
        <div className="metric-tile"><div className="eyebrow">Orders</div><div className="value" style={{ color: 'var(--neon-cyan)' }}>{orders.length}</div></div>
      </div>

      <div className="card">
        <table className="data-table">
          <thead><tr><th>Created</th><th>User</th><th>Token</th><th>Side</th><th>Qty</th><th>Price</th><th>Status</th></tr></thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id}>
                <td>{new Date(order.created_at).toLocaleString('en-IN')}</td>
                <td>{order.user_id}</td>
                <td>{order.token_class_id}</td>
                <td>{order.side}</td>
                <td>{Number(order.quantity).toLocaleString('en-IN')}</td>
                <td>₹{Number(order.limit_price || 0).toLocaleString('en-IN')}</td>
                <td>{order.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
